import { render, staticRenderFns } from "./aiAssistantSettings.vue?vue&type=template&id=5bc1445e&scoped=true"
import script from "./aiAssistantSettings.vue?vue&type=script&lang=js"
export * from "./aiAssistantSettings.vue?vue&type=script&lang=js"
import style0 from "./aiAssistantSettings.vue?vue&type=style&index=0&id=5bc1445e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1445e",
  null
  
)

export default component.exports